import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'
import { lsGet } from 'utils/request'

export const useBanners = (webviewName, displayOpt = null, swrOptions = {}) => {
  const defaultSwrOptions = { revalidateOnFocus: false } // 由於 banner 加入隨機排序設定，所以不在 focus 時重新抓取，以免影響使用者體驗
  const visibleSource = !webviewName ? 'lsWeb' : webviewName
  const genUrl = () => {
    const getBannersUrl = '/banners/client?'
    let getBannersUrlQueryData = { visibleSource, displayAt: 'homepage' }
    if (displayOpt)
      getBannersUrlQueryData = { ...getBannersUrlQueryData, ...displayOpt }
    return `${getBannersUrl}${stringify(getBannersUrlQueryData)}`
  }
  return useCustomSWR(genUrl, lsGet, { ...defaultSwrOptions, ...swrOptions })
}
